var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsiLogoSx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFBF48",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.806 4.348A14.5 14.5 0 0 0 0 18.208a.515.515 0 0 0 .555.528c1.821-.107 3.653-.194 5.496-.26a.112.112 0 0 0 .104-.113A20.399 20.399 0 0 1 11.85 4.461a.06.06 0 0 0-.044-.113zM28.355.017a1.628 1.628 0 0 0-.225 0L16.519 1.52A2.057 2.057 0 0 0 12.68 1.5C9.351 1.009 2.478 0 2.287 0a.801.801 0 0 0-.667.364C1.503.567.16 3.114.13 3.174a.797.797 0 0 0 .715 1.087c.075.006.15.006.225 0L12.2 2.82c-.043.25-.07.504-.077.758a.07.07 0 0 0 .078.07 14.582 14.582 0 0 1 4.777.004.048.048 0 0 0 .052-.043 4.889 4.889 0 0 0-.074-.767c3.465.507 9.775 1.434 9.961 1.434a.797.797 0 0 0 .672-.36c.117-.203 1.46-2.754 1.49-2.815a.865.865 0 0 0 .056-.286.801.801 0 0 0-.78-.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.239 17.038a18.666 18.666 0 0 0-4.846-12.56.896.896 0 0 0-.602-.299 13.69 13.69 0 0 0-1.196-.052c-.463 0-.922.026-1.377.065a.485.485 0 0 0-.303.152 18.688 18.688 0 0 0-4.963 12.707c0 .308 0 .615.021.918a.455.455 0 0 0 .472.433c2.045-.052 4.095-.08 6.15-.082 2.056-.003 4.106.025 6.15.082a.433.433 0 0 0 .468-.433c.017-.316.026-.628.026-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.337 4.44a20.403 20.403 0 0 1 5.696 13.906.117.117 0 0 0 .108.113c1.842.063 3.674.15 5.496.26a.516.516 0 0 0 .554-.529 14.496 14.496 0 0 0-11.81-13.842.05.05 0 1 0-.044.091z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsiLogoSx);
export default __webpack_public_path__ + "static/media/bsi-logo-sx.8b389af17aa3e05f596ff21bbe5d17a8.svg";
export { ForwardRef as ReactComponent };